import * as HydraNavState from '@customerio/hydra-nav-state';
import * as HydraPlumaState from '@customerio/hydra-pluma-state';
import { isHydraRoute } from '@/services/router/generate-path';

export default function injectGlobals() {
  Object.assign(window, {
    HydraNavState,
    HydraPlumaState,
    // Expose routing utilities for Ember to check if a URL belongs to Hydra
    __hydra__: {
      ...window.__hydra__,
      isHydraRoute,
    },
  });
}
